/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function () {

				// ----- mobile menu js
				$('.j-mobile-trigger').on('click',function(){
					$('.y-mobile').addClass('active');
				});
				$('.j-mobile--close').on('click',function(){
					$('.y-mobile').removeClass('active');
				});

				// ----- national side nav js
				$('.j-side-nat-trigger').on('click',function(){
					$('.y-side-nat').addClass('active');
				});
				$('.j-side-nat--close').on('click',function(){
					$('.y-side-nat').removeClass('active');
				});

				$('.side-menu--toggle').on('click',function(e){
					e.preventDefault();
					$(this).toggleClass('active');
					$(this).siblings('.sub-menu').slideToggle();
				});

				// ----- gallery slider. Appears in the Intro and Contact + Image Gallery Gutenberg blocks
				$('.y-c-gallery--slick').each(function(){
					var slider = $(this);
					slider.slick({
						'slide' : '.y-c-gallery--slide',
						'rows' : 0,
						'fade' : true,
						'infinite' : true,
						'dots' : true,
						'arrows' : true,
						'prevArrow' : '<svg class="slick-prev" width="17" height="29" viewBox="0 0 17 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5 27L3 14.5L15.5 2" stroke="white" stroke-width="3"/></svg>',
						'nextArrow' : '<svg class="slick-next" width="17" height="29" viewBox="0 0 17 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14.5 14.5L2 27" stroke="white" stroke-width="3"/></svg>',
						customPaging: function(slider,i){
							return '<span style="background-image: url('+ $(slider.$slides[i]).data('thumb') + ')"></span>';
						}
					});
				});


				// ----- image slider. Appears in the Image Slider Gutenberg block
				$('.y-image-slider--slick').each(function(){
					var slider = $(this);
					var paging = $(this).data('paging');
					if ( paging === 'dots' ) {
						slider.slick({
							'slide' : '.y-image-slider--slide',
							'rows' : 0,
							'fade' : true,
							'infinite' : true,
							'dots' : true,
							'arrows' : true,
							'prevArrow' : '<svg class="slick-prev" width="17" height="29" viewBox="0 0 17 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5 27L3 14.5L15.5 2" stroke="white" stroke-width="3"/></svg>',
							'nextArrow' : '<svg class="slick-next" width="17" height="29" viewBox="0 0 17 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14.5 14.5L2 27" stroke="white" stroke-width="3"/></svg>'
						});
					}
					if ( paging === 'thumbs' ) {
						slider.slick({
							'slide' : '.y-image-slider--slide',
							'rows' : 0,
							'fade' : true,
							'infinite' : true,
							'dots' : true,
							'arrows' : true,
							'prevArrow' : '<svg class="slick-prev" width="17" height="29" viewBox="0 0 17 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5 27L3 14.5L15.5 2" stroke="white" stroke-width="3"/></svg>',
							'nextArrow' : '<svg class="slick-next" width="17" height="29" viewBox="0 0 17 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14.5 14.5L2 27" stroke="white" stroke-width="3"/></svg>',
							customPaging: function(slider,i){
								return '<span style="background-image: url('+ $(slider.$slides[i]).data('thumb') + ')"></span>';
							}
						});
					}
				});


				// ----- logo slider. Appears in the Logo Slider Gutenberg block
				$('.y-logo-slider--slick').each(function() {
					var logo_slider = $(this);
					logo_slider.slick({
						'slide' : '.y-logo-slider--single',
						'rows' : 0,
						'centerMode' : true,
						'centerPadding' : '20px',
						'fade' : false,
						'infinite' : true,
						'speed' : 200,
						'dots' : false,
						'slidesToShow' : 5,
						'slidesToScroll' : 1,
						'adaptiveHeight' : true,
						'arrows' : true,
						'prevArrow' : '<svg class="slick-prev" width="16" height="29" viewBox="0 0 16 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 27.5L2 14.5L15 1.5" stroke="#C6481E" stroke-width="2"/></svg>',
						'nextArrow' : '<svg class="slick-next" width="16" height="29" viewBox="0 0 16 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L14 14.5L1 27.5" stroke="#C6481E" stroke-width="2"/></svg>',
						'responsive' : [
							{
								'breakpoint' : 1024,
								'settings' : {
									'slidesToShow' : 3,
								}
							},
							{
								'breakpoint' : 768,
								'settings' : {
									'slidesToShow' : 2,
								}
							},
							{
								'breakpoint' : 550,
								'settings' : {
									'centerMode' : false,
									'slidesToShow' : 1,
								}
							}
						]

					});
				});


				//  ----- card slider. Appears in the Card Slider Gutenberg block
				$('.y-card-slider--slick').each(function() {
					var card_slider = $(this);
					card_slider.slick({
						'fade' : false,
						'infinite' : true,
						'dots' : true,
						'arrows' : false,
						'slidesToShow' : 3,
						'slidesToScroll' : 3,
						'adaptiveHeight' : true,
						'responsive' : [
							{
								'breakpoint' : 1024,
								'settings' : {
									'slidesToShow' : 2,
									'slidesToScroll' : 2,
								}
							},
							{
								'breakpoint' : 768,
								'settings' : {
									'slidesToShow' : 1,
									'slidesToScroll' : 1,
								}
							}
						]
					});
				});

				var pin_fill = $('.acf-map').data('fill');

				// ----- Google Maps ACF functionality
				/**
				 * initMarker
				 *
				 * Creates a marker for the given jQuery element and map.
				 *
				 * @date    22/10/19
				 * @since   5.8.6
				 *
				 * @param   jQuery $el The jQuery element.
				 * @param   object The map instance.
				 * @return  object The marker instance.
				 */
				function initMarker( $marker, map  ) {

					// Get position from marker.
					var lat = $marker.data('lat');
					var lng = $marker.data('lng');
					var latLng = {
						lat: parseFloat( lat ),
						lng: parseFloat( lng )
					};

					

					// customise the marker
					var icon = {
						path: "M13.5 1C6.58511 1 1 6.5851 1 13.5C1 23.1884 13.5 35.1945 13.5 35.1945C13.5 35.1945 26 23.1504 26 13.5C26 6.5851 20.4149 1 13.5 1Z",
						// fillColor: '<?php echo $pin_fill; ?>',
						fillColor: pin_fill,
						fillOpacity: 1,
						anchor: new google.maps.Point(0,0),
						strokeColor: '#fff',
						strokeWeight: 2
					};

					// Create marker instance.
					var marker = new google.maps.Marker({
						position : latLng,
						map: map,
						icon: icon
					});

					// Append to reference for later use.
					map.markers.push( marker );

					// If marker contains HTML, add it to an infoWindow.
					if( $marker.html() ){

						// Create info window.
						var infowindow = new google.maps.InfoWindow({
							content: $marker.html()
						});

						// Show info window when marker is clicked.
						google.maps.event.addListener(marker, 'click', function() {
							infowindow.open( map, marker );
						});
					}
				}

				/**
				 * centerMap
				 *
				 * Centers the map showing all markers in view.
				 *
				 * @date    22/10/19
				 * @since   5.8.6
				 *
				 * @param   object The map instance.
				 * @return  void
				 */
				function centerMap( map ) {

					// Create map boundaries from all map markers.
					var bounds = new google.maps.LatLngBounds();
					map.markers.forEach(function( marker ){
						bounds.extend({
							lat: marker.position.lat(),
							lng: marker.position.lng()
						});
					});

					// Case: Single marker.
					if( map.markers.length === 1 ){
						map.setCenter( bounds.getCenter() );

					// Case: Multiple markers.
					} else{
						map.fitBounds( bounds );
					}
				}


				/**
				 * initMap
				 *
				 * Renders a Google Map onto the selected jQuery element
				 *
				 * @date    22/10/19
				 * @since   5.8.6
				 *
				 * @param   jQuery $el The jQuery element.
				 * @return  object The map instance.
				 */
				function initMap( $el ) {

					// Find marker elements within map.
					var $markers = $el.find('.marker');

					// Create gerenic map.
					var mapArgs = {
						zoom        : $el.data('zoom') || 16,
						mapTypeId   : google.maps.MapTypeId.ROADMAP,
						styles      : [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.country","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.country","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.country","elementType":"labels.text","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"visibility":"simplified"},{"saturation":"-100"},{"lightness":"30"}]},{"featureType":"administrative.neighborhood","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"simplified"},{"gamma":"0.00"},{"lightness":"74"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"landscape.man_made","elementType":"all","stylers":[{"lightness":"3"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}]
					};
					var map = new google.maps.Map( $el[0], mapArgs );

					// Add markers.
					map.markers = [];
					$markers.each(function(){
						initMarker( $(this), map );
					});

					// Center map based on markers.
					centerMap( map );

					// Return map instance.
					return map;
				}


				// Render maps on page load.
				$(document).ready(function(){
					$('.acf-map').each(function(){
						var map = initMap( $(this) );
					});
				});


				// ----- ajax CPT functionality
				function updateBlogPosts(permalink){
					loadmore = $('.j-load-more');
					$('html,body').animate({
						scrollTop: $('.j-filter--scroll-target').offset().top - 100
					 }, 200 );
					window._fetch.callbackContent(permalink, function(newPage) {
						var $newPage = $(newPage);
						loadmore.find('.j-load-more--posts').html($newPage.find('.j-load-more--posts').html());
						loadmore.find('.j-filters').html($newPage.find('.j-filters').html());
						loadmore.find('.j-filter--count').html($newPage.find('.j-filter--count').html());
						loadmore.find('.j-load-more--pagination').html($newPage.find('.j-load-more--pagination').html());
						loadmore.find('.j-load-more--map').html($newPage.find('.j-load-more--map').html());
						loadmore.find('.j-cards-search').html($newPage.find('.j-cards-search').html());
						window._fetch.setURL(permalink);
						$('.acf-map').each(function(){ var map = initMap( $(this) ); });
					});
				}

				$('.j-load-more').on('click','.y-pagination a',function(e){
					e.preventDefault();
					updateBlogPosts($(this).attr('href'));
				});

				$('.j-load-more').on('change', '.j-post-filter', function(){
					var permalink = $(this).data('permalink');
					var extension = "?";
					$('.j-post-filter').each(function(){
						var _this = $(this);
						var value = _this.val();
						var array = value.split('__');
						if(array[0].length > 1 ){
							permalink += extension + array[0] + "=" + array[1];
							extension = "&";
						}
					});
					updateBlogPosts(permalink);
				});

				$('.j-load-more').on('submit', '.j-cards-search', function(e){
				// $('.j-cards-search').on('submit',function(e){
					e.preventDefault();
					var permalink = $(this).attr('action');
					var search = $(this).find('#card--search').val();
					search = search.toLowerCase();
					search = search.replace(/(^\s+|[^a-zA-Z0-9 ]+|\s+$)/g,"");   //this one
					search = search.replace(/\s+/g, "+");
					permalink = permalink + '?sq=' + search;
					updateBlogPosts(permalink);
				});



				// ----- ajax CPT functionality for POSTS
				function get_filter_values( filter_class ) {
					var value_array = [];
					$.each($(filter_class + " input:checked"), function(){
						value_array.push($(this).val());
					});
					return value_array;
				}

				function get_filtered_url(){
					var container = $('.j-ajax--container');
					var base_url = container.data('permalink');

					var filter_one_options = get_filter_values( '.filter_class_one' );
					var filter_one_tax = $('.filter_class_one').data('tax');
					var filter_two_options = get_filter_values( '.filter_class_two' );
					var filter_two_tax = $('.filter_class_two').data('tax');

					var search_value = $('.j-ajax--search input').val();

					// start with a ?, once query_param is used we will switch it to & for any future additions.
					var query_param = "?";

					// if there are any filter options for the first filter, add them to the url
					if( filter_one_options.length > 0 ){
						base_url += query_param + filter_one_tax + '=' + filter_one_options.join(',');
						// Switch to & for future parameters
						query_param = "&";
					}

					// if there are any filter options for the second filter, add them to the url
					if( filter_two_options.length > 0 ){
						base_url += query_param + filter_two_tax + '=' + filter_two_options.join(',');
						// Switch to & for future parameters
						query_param = "&";
					}

					// if there is any search value used, add it to the url
					if( search_value.length > 0 ){
						search_value = search_value.toLowerCase();
						search_value = search_value.replace(/(^\s+|[^a-zA-Z0-9 ]+|\s+$)/g,"");   //this one
						search_value = search_value.replace(/\s+/g, "+");

						base_url += query_param + 'sq=' + search_value;
						// Switch to & for future parameters
						query_param = "&";
					}

					return base_url;
				}

				// $('.j-ajax--filter').on('change', 'input', function(){
				// 	var url = get_filtered_url();
				// 	updateBlogPosts(url);
				// 	console.log(url);
				// });

				// $('.j-ajax--search').on('submit',function(e){
				// 	e.preventDefault();
				// 	var url = get_filtered_url();
				// 	updateBlogPosts(url);
				// 	console.log(url);
				// });
				

				$('.j-ajax').on('change', '.j-ajax--filter input', function(){
					var url = get_filtered_url();
					updateBlogPosts(url);
					console.log(url);
				});

				$('.j-ajax').on('submit', '.j-ajax--search', function(e){
					e.preventDefault();
					var url = get_filtered_url();
					updateBlogPosts(url);
					console.log(url);
				});


				// ----- posts block show filters button
				$('.y-posts--filters--mobile-toggle').on('click',function(e){
					e.preventDefault();
					$('.y-cards--filter-container.checkbox').slideToggle();
				});


				// ----- posts block show filters button
				$('.y-accordion--single--title').on('click',function(){
					$(this).toggleClass('active');
					$(this).siblings('.y-accordion--single--content').slideToggle();
				});

				/**
				 * Donation Form conditional value population based on "designation"
				 * field selected value
				 */

				  function populateHiddenDesignationField(designation, hidden, category) {
				        hidden.val(category + ' - ' + designation);
				  }
				
				  var designation_default = $('.donate_des.des_default select'),
				  	  designation = $('.donate_des select'),
				      category = $('.donate_cat select').val(),
				      hidden = $('.hidden_des input');

				  populateHiddenDesignationField(designation_default.val(), hidden, category);

				  designation.on('change', function() {
				  		category = $('.donate_cat select').val();
				  		populateHiddenDesignationField(this.value, hidden, category);
				  });

			},
			finalize: function () {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function () {
				// JavaScript to be fired on the home page
			},
			finalize: function () {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function () {
				// JavaScript to be fired on the about us page
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function (func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function () {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.